<!-- Mobile nav: collapsed bar + overlay dropdown -->
<ng-container id="navigation-pendo-row" *ngIf="sectionTitle; else desktopNav">
    <ng-container *ngIf="forceState !== showHideState.Hide">
        <!-- Collapsed bar: hamburger + page title -->
        <div class="mobile-nav-bar" (click)="toggleDrawer()">
            <atlas-icon [icon]="sideNavExpanded ? 'close' : 'menu'" collection="user-interface"
                class="mobile-nav-bar__icon"></atlas-icon>
            <span class="mobile-nav-bar__title">{{ sectionTitle }}</span>
        </div>

        <!-- Backdrop overlay when nav is open -->
        <div class="mobile-nav-backdrop" *ngIf="sideNavExpanded" (click)="toggleDrawer()"></div>

        <!-- Expanded nav items dropdown -->
        <div class="mobile-nav-dropdown" *ngIf="sideNavExpanded">
            <atlas-navigation-drawer-item *ngFor="let item of topNavigation || []" [icon]="item.icon" [size]="'dense'"
                [collectionIcon]="item.iconCollection" [text]="item.name"
                [state]="isItemActive(item) ? 'active' : 'default'" [class.dsp-nav-active]="isItemActive(item)"
                [collapsed]="false" (itemClick)="onNavigationClick(item)"></atlas-navigation-drawer-item>

            <atlas-navigation-drawer-item *ngFor="let item of bottomNavigation || []" [icon]="item.icon"
                [size]="'dense'" [collectionIcon]="item.iconCollection" [text]="item.name"
                [state]="isItemActive(item) ? 'active' : 'default'" [class.dsp-nav-active]="isItemActive(item)"
                [collapsed]="false" (itemClick)="onNavigationClick(item)"></atlas-navigation-drawer-item>
        </div>
    </ng-container>
</ng-container>

<!-- Desktop nav: original atlas-navigation-drawer behavior -->
<ng-template #desktopNav>
    <atlas-navigation-drawer class="dsp-app-navigation-drawer" [expanded]="sideNavExpanded">
        <ng-container *ngIf="forceState !== showHideState.Hide">
            <div *ngIf="sideNavExpanded; else collapsedHeader"
                class="drawer-header drawer-header atlas-navigation-drawer-item atlas-navigation-drawer-item--dense drawer-expand"
                (click)="toggleDrawer()">
                <span class="drawer-header__title">Menu</span>
                <atlas-icon icon="close" collection="user-interface" class="menu-close"></atlas-icon>
            </div>
            <ng-template #collapsedHeader>
                <div class="drawer-header drawer-header--collapsed" (click)="toggleDrawer()">
                    <atlas-icon icon="menu" collection="user-interface"
                        class="atlas-navigation-drawer-item"></atlas-icon>
                </div>
            </ng-template>

            <atlas-navigation-drawer-item *ngFor="let item of topNavigation || []" [icon]="item.icon" [size]="'dense'"
                [collectionIcon]="item.iconCollection" [text]="item.name"
                [state]="isItemActive(item) ? 'active' : 'default'" [class.dsp-nav-active]="isItemActive(item)"
                [collapsed]="!sideNavExpanded" (itemClick)="onNavigationClick(item)" [haloTooltip]="item.name"
                [haloTooltipPosition]="'right'"></atlas-navigation-drawer-item>

            <atlas-navigation-drawer-item *ngFor="let item of bottomNavigation || []" [icon]="item.icon"
                [size]="'dense'" [collectionIcon]="item.iconCollection" [text]="item.name"
                [state]="isItemActive(item) ? 'active' : 'default'" [class.dsp-nav-active]="isItemActive(item)"
                [collapsed]="!sideNavExpanded" (itemClick)="onNavigationClick(item)" [haloTooltip]="item.name"
                [haloTooltipPosition]="'right'"></atlas-navigation-drawer-item>
        </ng-container>
    </atlas-navigation-drawer>
</ng-template>